import { PerformanceReviewEditPageStep } from "@/pages/talent/performance-reviews/edit/performance-review-edit.ts";
import { ApiPerformanceReviewEdit } from "@/types/performance-review.types.ts";
import { ConfirmationModal, useModals } from "@skailer-com/uikit";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

export interface PerformanceReviewEditPageProps {
  review: ApiPerformanceReviewEdit;
}

export const usePerformanceReviewEditPage = () => {
  const { openModal } = useModals();
  const { t } = useTranslation();
  const navigate = useNavigate();

  const exit = (id: number) => {
    navigate(`/performance-reviews/${id}/view/participants`);
  };

  const confirmExit = (id: number) => {
    openModal(ConfirmationModal, {
      question: t("common:unsaved_changes_may_be_lost_title"),
      text: t("common:unsaved_changes_may_be_lost_description"),
      acceptTitle: t("common:leave"),
      secondButtonTitle: t("common:stay"),
      onAccept: async function () {
        exit(id);
      },
    });
  };

  const navigateToStep = (id: number, newStep: PerformanceReviewEditPageStep) => {
    navigate(`/performance-reviews/${id}/setup/${newStep}`);
  };

  const navigateToEditForm = (id: number, typeId: number | null) => {
    if (!typeId) return;
    navigate(`/performance-reviews/${id}/setup/${PerformanceReviewEditPageStep.forms}/${typeId}`);
  };

  return {
    exit,
    confirmExit,
    navigateToStep,
    navigateToEditForm,
  };
};
